import * as React from "react";
import styled, { css } from "styled-components";
import { HelpBlock, ListGroup, ListGroupItem } from "components/bootstrap";
const Section = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
  `
);
const Title = styled.h4(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};
    font-size: ${theme.fonts.size.body};
    font-weight: 600;
  `
);
const List = styled(ListGroup)(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.table.row.divider};
    border-radius: 4px;
  `
);
const Usage = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacings.md};
    padding: ${theme.spacings.xs} ${theme.spacings.sm};
  `
);
const Secondary = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const Model = styled.code(
  ({ theme }) => css`
    padding: 0;
    background: none;
    color: inherit;
    font-family: ${theme.fonts.family.monospace};
  `
);
const DefaultModelHint = styled(Secondary)`
  font-style: italic;
`;
const UsedByFeatures = ({ usages, defaultModelId }) => /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Title, null, "Used by"), usages.length === 0 ? /* @__PURE__ */ React.createElement(HelpBlock, null, "No AI feature uses this model provider.") : /* @__PURE__ */ React.createElement(List, { "aria-label": "AI features using this model provider" }, usages.map(({ feature, title, category, model_id: modelId }) => /* @__PURE__ */ React.createElement(ListGroupItem, { key: feature }, /* @__PURE__ */ React.createElement(Usage, null, /* @__PURE__ */ React.createElement("span", null, title, " ", /* @__PURE__ */ React.createElement(Secondary, null, "\u2014 ", category)), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Model, null, modelId != null ? modelId : defaultModelId), !modelId && /* @__PURE__ */ React.createElement(DefaultModelHint, null, " \u2014 default")))))));
export default UsedByFeatures;
